var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      !_vm.ZMLApp
        ? _c("TopNavigation", { attrs: { "top-act": "6" } })
        : _vm._e(),
      _vm.$store.state.webNavigator == "pc"
        ? _c("div", { staticClass: "search-box" }, [
            _c("div", { staticClass: "search-box-right" }, [
              _c("div", { staticClass: "search" }, [
                _c("div", { staticClass: "search-items" }, [
                  _c("p", { staticClass: "search-font36" }, [
                    _vm._v("产品防伪查询")
                  ]),
                  _c("p", { staticClass: "search-font22" }, [
                    _vm._v("请输入包装上16位防伪码，即可辨别真伪。")
                  ]),
                  _c("input", {
                    staticClass: "inspect",
                    attrs: {
                      id: "inspectID",
                      type: "text",
                      placeholder: "请输入您要查询的16位防伪码"
                    }
                  }),
                  _c("input", {
                    attrs: { type: "button", value: "查询" },
                    on: { click: _vm.querycode }
                  }),
                  _vm._m(0)
                ]),
                _c("div", { staticClass: "product-image" }, [
                  _c("img", {
                    staticClass: "product-image-img",
                    attrs: { src: _vm.src1, alt: "防伪编码", title: "" }
                  })
                ])
              ]),
              _c("div", { staticClass: "search" }, [
                _c("div", { staticClass: "search-items" }, [
                  _c("p", { staticClass: "search-font36" }, [
                    _vm._v("微信顾问查询")
                  ]),
                  _c("p", { staticClass: "search-font22" }, [
                    _vm._v("请输入您要查询的微信号，即可辨别真伪。")
                  ]),
                  _c("input", {
                    attrs: {
                      id: "wechatID",
                      type: "text",
                      placeholder: "请输入您要查询的微信号"
                    }
                  }),
                  _c("input", {
                    attrs: { type: "button", value: "查询" },
                    on: { click: _vm.querywechatcode }
                  }),
                  _vm._m(1)
                ]),
                _c("div", { staticClass: "search-items" }, [
                  _c("p", { staticClass: "search-font36" }, [
                    _vm._v("电话顾问查询")
                  ]),
                  _c("p", { staticClass: "search-font22" }, [
                    _vm._v("请输入您要查询的手机号或座机号。")
                  ]),
                  _c("input", {
                    attrs: {
                      id: "phoneID",
                      type: "text",
                      placeholder: "请输入您要查询的手机号或座机号"
                    }
                  }),
                  _c("input", {
                    attrs: { type: "button", value: "查询" },
                    on: { click: _vm.queryphone }
                  }),
                  _vm._m(2)
                ]),
                _c("div", { staticClass: "modal", attrs: { id: "modal" } }, [
                  _c("div", { staticClass: "modal-dialog" }, [
                    _c("div", { staticClass: "dialog-head" }, [
                      _vm._v("\n              脂玫乐提示您：\n              "),
                      _c("i", {
                        staticClass: "iconfont icon-pc-3 fr",
                        attrs: { id: "close" },
                        on: {
                          click: function($event) {
                            return _vm.closes()
                          }
                        }
                      })
                    ]),
                    _vm._m(3)
                  ])
                ])
              ])
            ])
          ])
        : _c("div", { class: _vm.classObject }, [
            _c(
              "div",
              { class: { "phone-Box": true, "app-phone-box": _vm.ZMLApp } },
              [
                _c("div", { staticClass: "banner-box" }, [
                  _c("p", { staticClass: "banner-tlt" }, [
                    _vm._v("产品防伪查询")
                  ]),
                  _c("p", { staticClass: "banner-p" }, [
                    _vm._v("请输入包装上16位防伪码，即可辨别真伪。")
                  ]),
                  _c("div", { staticClass: "part-input-box flexCenter" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchText1,
                          expression: "searchText1"
                        }
                      ],
                      staticClass: "part-input",
                      attrs: {
                        type: "text",
                        placeholder: "请输入您要查询的16位防伪码"
                      },
                      domProps: { value: _vm.searchText1 },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.searchText1 = $event.target.value
                        }
                      }
                    })
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "banner-btn",
                      on: { click: _vm.productReg }
                    },
                    [_vm._v("\n          查 询\n        ")]
                  ),
                  _vm._m(4),
                  _c("div", { staticClass: "banner-img" })
                ]),
                _c("div", { staticClass: "banner-box" }, [
                  _c("p", { staticClass: "banner-tlt" }, [
                    _vm._v("微信顾问查询")
                  ]),
                  _c("p", { staticClass: "banner-p" }, [
                    _vm._v("请输入您要查询的微信号，即可辨别真伪。")
                  ]),
                  _c("div", { staticClass: "part-input-box flexCenter" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchText2,
                          expression: "searchText2"
                        }
                      ],
                      staticClass: "part-input",
                      attrs: {
                        type: "text",
                        placeholder: "请输入您要查询的微信号"
                      },
                      domProps: { value: _vm.searchText2 },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.searchText2 = $event.target.value
                        }
                      }
                    })
                  ]),
                  _c(
                    "div",
                    { staticClass: "banner-btn", on: { click: _vm.weixinReg } },
                    [_vm._v("\n          查 询\n        ")]
                  ),
                  _vm._m(5)
                ]),
                _c("div", { staticClass: "banner-box" }, [
                  _c("p", { staticClass: "banner-tlt" }, [
                    _vm._v("电话顾问查询")
                  ]),
                  _c("p", { staticClass: "banner-p" }, [
                    _vm._v("请输入您要查询的手机号或座机号，即可辨别真伪。")
                  ]),
                  _c("div", { staticClass: "part-input-box flexCenter" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchText3,
                          expression: "searchText3"
                        }
                      ],
                      staticClass: "part-input",
                      attrs: {
                        type: "text",
                        placeholder: "请输入您要查询的手机号或座机号"
                      },
                      domProps: { value: _vm.searchText3 },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.searchText3 = $event.target.value
                        }
                      }
                    })
                  ]),
                  _c(
                    "div",
                    { staticClass: "banner-btn", on: { click: _vm.phoneReg } },
                    [_vm._v("\n          查 询\n        ")]
                  ),
                  _vm._m(6)
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showStatus,
                        expression: "showStatus"
                      }
                    ],
                    staticClass: "page-reg-big-box flexCenter"
                  },
                  [
                    _c("div", { staticClass: "page-reg-box" }, [
                      _c("div", { staticClass: "page-reg-top flexSpace" }, [
                        _c("div", { staticClass: "page-reg-title" }, [
                          _vm._v("脂玫乐提示您：")
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "page-reg-close-box",
                            on: { click: _vm.changeAlertStatus }
                          },
                          [
                            _c("img", {
                              staticClass: "page-reg-close-icon",
                              attrs: {
                                src:
                                  "https://jusewebapp.zmelo.com/zml-gw/phone/huicha.png",
                                title: "",
                                alt: ""
                              }
                            })
                          ]
                        )
                      ]),
                      _vm.searchType == "1"
                        ? _c("div", { staticClass: "reg-text-box1" }, [
                            _c("div", { staticClass: "reg-text1" }, [
                              _vm._v("经系统验证")
                            ]),
                            _c("div", { staticClass: "reg-text1" }, [
                              _vm._v(
                                "您所查询的防伪编码(" +
                                  _vm._s(_vm.searchText1) +
                                  ") "
                              ),
                              _c(
                                "span",
                                {
                                  class:
                                    _vm.findResult == "1" ? "success" : "error"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.findResult == "1" ? "存在" : "不存在"
                                    )
                                  )
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "reg-text1" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.findResult == "1"
                                    ? "谢谢您的查询"
                                    : "请您核实后再试谢谢您的查询"
                                ) + "，"
                              )
                            ])
                          ])
                        : _c("div", { staticClass: "reg-text-box2" }, [
                            _c(
                              "div",
                              { staticClass: "reg-value-box flexCenter" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "reg-value-icon-box" },
                                  [
                                    _c("img", {
                                      staticClass: "reg-value-icon",
                                      attrs: {
                                        src:
                                          _vm.findResult == "1"
                                            ? "https://jusewebapp.zmelo.com/zml-gw/etyjg1.png"
                                            : _vm.findResult == "3"
                                            ? "https://jusewebapp.zmelo.com/zml-gw/etyjg2.png"
                                            : "https://jusewebapp.zmelo.com/zml-gw/etyjg3.png",
                                        alt: "",
                                        title: ""
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "reg-value",
                                    class:
                                      _vm.findResult == "1"
                                        ? "success"
                                        : "error"
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.searchType == "2"
                                            ? _vm.searchText2
                                            : _vm.searchText3
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _c("div", { staticClass: "reg-value-remind" }, [
                              _vm._v(
                                "\n              您所查询的\n              "
                              ),
                              _vm.searchType == "2"
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "reg-value-remind-result",
                                      class:
                                        _vm.findResult == "1"
                                          ? "success"
                                          : "error"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.searchType + _vm.findResult == "1"
                                            ? "微信号为官方客服微信号码"
                                            : _vm.findResult == "3"
                                            ? "微信号为非官方微信号"
                                            : _vm.findResult == "2"
                                            ? "微信号为本公司其他品牌客服微信号"
                                            : "查询失败"
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.searchType == "3"
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "reg-value-remind-result",
                                      class:
                                        _vm.findResult == "1"
                                          ? "success"
                                          : "error"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.searchType + _vm.findResult == "1"
                                            ? "电话号码为官方客服电话号码"
                                            : _vm.findResult == "3"
                                            ? "电话号码为非官方客服电话号码"
                                            : _vm.findResult == "2"
                                            ? "电话号码为本公司其他品牌客服电话号码"
                                            : "查询失败"
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                      _c(
                        "div",
                        {
                          staticClass: "reg-result-text",
                          class: _vm.findResult == "1" ? "success" : "error"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.findResult != "3"
                                  ? "谢谢您的查询!"
                                  : _vm.findResult == "4"
                                  ? ""
                                  : "谨防上当受骗！"
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]
            )
          ]),
      !_vm.ZMLApp ? _c("FooterNavigation") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search-font16" }, [
      _c("p", [
        _vm._v("1、防伪查询的方式共有三种：微信查询、电话查询、网站查询；")
      ]),
      _c("p", [
        _vm._v(
          " 2、正规的防伪码由16位数字组成，查询时请刮去涂层，数一下你的防伪码是不是16位数字。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "search-font16", staticStyle: { "text-align": "left" } },
      [
        _c("p", [
          _vm._v(
            "1、在查询框内输入微信号可以查询你的唯一专属顾问查询是否为真伪；"
          )
        ]),
        _c("p", [
          _vm._v(
            " 2、脂玫乐健康团队专属顾问均可查询，如果输入专属顾问微信号查询提示为“此微信号为脂玫乐健康团队专属顾问”则为真，提示为不是或其他提示均不是脂玫乐健康团队产品专属顾问号。"
          )
        ]),
        _c("p", { staticClass: "tip" }, [
          _c("span", [_vm._v("温馨提示：")]),
          _vm._v(
            "\n              此为脂玫乐健康团队专属顾问微信号真伪查询，官方唯一认证渠道，其余均为仿冒！\n            "
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "search-font16", staticStyle: { "text-align": "left" } },
      [
        _c("p", [
          _vm._v(
            "1、在查询框内输入座机号（请加区号）可以查询你的唯一专属顾问查询是否为真伪；"
          )
        ]),
        _c("p", [
          _vm._v(
            " 2、脂玫乐健康团队专属顾问均可查询，如果输入专属顾问座机号查询提示为“此手机号或座机号为脂玫乐 健康团队专属顾问”则为真，提示为不是或其他提示均不是脂玫乐健康团队产品专属顾问号。"
          )
        ]),
        _c("p", { staticClass: "tip" }, [
          _c("span", [_vm._v("温馨提示：")]),
          _vm._v(
            "\n              此为脂玫乐健康团队专属顾问手机号或座机号真伪查询，官方唯一认证渠道，其余均为仿冒！\n            "
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dialog-body" }, [
      _c("p", [_c("i"), _c("span", { attrs: { id: "code" } })]),
      _c("p", { staticClass: "message" }, [
        _vm._v("您所查询的"),
        _c("span", { attrs: { id: "result" } })
      ]),
      _c("p", { staticClass: "tip", attrs: { id: "tip" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "banner-text" }, [
      _vm._v(
        "\n          1、防伪查询的方式共有三种：微信查询、电话查询、网站查询； "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n          2、正规的防伪码由16位数字组成，查询时请刮去涂层， 数一下你的防伪码是不是16位数字。\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "banner-text" }, [
      _vm._v(
        "\n\n          1、在查询框内输入微信号可以查询你的唯一专属顾问查询是否为真伪； "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n          2、脂玫乐健康团队专属顾问均可查询，如果输入专属顾问微信号查询提示为“此微信号为脂玫乐健康团队专属顾问”则为真，提示为不是或其他提示均不是脂玫乐健康团队产品专属顾问号。"
      ),
      _c("br"),
      _c("br"),
      _c("span", { staticStyle: { color: "#00CDA2" } }, [_vm._v("温馨提示：")]),
      _vm._v(
        "此为脂玫乐健康团队专属顾问微信号真伪查询，官方唯一认证渠道，其余均为仿冒！\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "banner-text" }, [
      _vm._v(
        "\n          1、在查询框内输入手机号或座机号（请加区号）可以查询你的唯一专属顾问查询是否为真伪；"
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n          2、脂玫乐健康团队专属顾问均可查询，如果输入专属顾问微信号查询提示为“此手机号或座机号为脂玫乐 健康团队专属顾问”则为真，提示为不是或其他提示均不是脂玫乐健康团队产品专属顾问号。"
      ),
      _c("br"),
      _c("br"),
      _c("span", { staticStyle: { color: "#00CDA2" } }, [_vm._v("温馨提示：")]),
      _vm._v(
        "此为脂玫乐健康团队专属顾问手机号或座机号真伪查询，官方唯一认证渠道，其余均为仿冒！\n        "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a5eff1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a5eff1e","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/search/search.vue
// module id = 993
// module chunks = 16